// Coquille des pages : une seule source de verite pour la largeur, la
// gouttiere et le seuil de bascule en deux colonnes. Avant, chaque page
// repondait a ces questions dans son coin : Jam plafonnait a 1320 et basculait
// a 1000 par container query, You n'avait aucun plafond et basculait a 900 par
// mesure JS. Entre 900 et 1000 les deux onglets n'avaient pas la meme mise en
// page, et rien ne signalait la divergence.

export const PAGE_MAX_WIDTH = 1320;
export const PAGE_GUTTER = 16;
// Recul du contenu sous le haut de la page, titre compris.
export const PAGE_TOP = 16;

// Deux colonnes des que la page a la largeur. La hauteur compte aussi :
// l'iPad portrait (834 x 1112) merite le maitre-detail, l'iPhone paysage
// (844 x 390) non, alors que les deux depassent 800 px de large.
export const SPLIT_MIN_WIDTH = 900;
export const SPLIT_TALL_MIN_WIDTH = 800;
export const SPLIT_TALL_MIN_HEIGHT = 700;

export const isSplitSize = (width, height) =>
  width >= SPLIT_MIN_WIDTH
  || (width >= SPLIT_TALL_MIN_WIDTH && height >= SPLIT_TALL_MIN_HEIGHT);
